import {
	takeLatest, call, put, fork,
} from 'redux-saga/effects';
import _ from 'lodash';
import request from '../../utils/request';
import API from '../../config/api';
import {
	LOAD_CHECKLIST,
	SEND_RESPONSE,
	LOAD_RESPONSES_BY_IDS,
	LOAD_CHECKLIST_RESPONSES,
	SEND_PICTURE_RESPONSE,
	SEND_QUE_RESPONSE,
} from './constants';
import {
	checklistLoadedSuccess,
	checklistLoadedFail,
	sendResponseFail,
	sendResponseSuccess,
	loadResponsesSuccess,
	loadResponsesFail,
	sendQuePictureSuccess,
	sendQueResponseSuccess,
	sendPicturesInQue,
	sendInQue,
} from './actions';
import { loadNotifications } from '../NotificationsProvider/actions';
import firestore from '@react-native-firebase/firestore';
import login from '../../services/login';
import { uploadToS3 } from '../../utils/s3Helper';
// load response
function* loadResponses({ id, date }) {
	const url = `${API()}/dataservice/checklist/response/extended`;
	const options = {
		url,
		method: 'GET',
		params: {
			ajax: true,
			field1: 'response',
			field2: id?.toString(),
			date
		},
	};
	try {
		const { data } = yield call(request, options);

		if (data !== 'error') {
			// console.log(data,"dataservice data");
			yield put(loadResponsesSuccess(data?.content));
		} else {
			console.warn(data);
			yield put(loadResponsesFail(data));
		}
	} catch (err) {
		console.warn(err);
		yield put(loadResponsesFail(err));
	}
}

// send Response related
function* sendQueResponse(response) {
	console.log(response, "response");
	const user = yield call(login.getUser);
	const { personId, email } = user;
	const url = `${API()}/sbmicroservice/checklistQueue`;
	const options = {
		url,
		method: 'POST',
		params: { checklist: response.checklist, personId: personId, v2: true, ajax: true, date: response.question0date },
		data: response,
		headers: {
			'Content-Type': 'application/json',
		},
	};
	try {
		const { data } = yield call(request, options);
		console.log(data, "data545454");
		//segmentClient.track('Responses Added Success', data);
		if (data.error) {
			console.warn(data.error);
			const todayDate = new Date().toLocaleString().replaceAll('/', '-').replace(' ', '').split(','); // Get the current date
			firestore()
				.collection(`Errors/checklist/${response.checklist}/Que/${todayDate[0]}`)
				.doc(todayDate[1]) // Specify a document ID (or let Firestore generate one)
				.set({
					error: JSON.stringify(data),  // Assuming 'error' is an object you want to store
					timestamp: new Date().toLocaleString(), // Optional: add a timestamp
				});
		} else if (data?.data?.ok && data?.data?.checkListId && Number(data?.data?.checkListId) > 0) {
			yield put(sendQueResponseSuccess(response));
			const todayDate = new Date().toLocaleString().replaceAll('/', '-').replace(' ', '').split(','); // Get the current date
			firestore()
				.collection(`Responces/checklist/${response.checklist}/Que/${todayDate[0]}`)
				.doc(todayDate[1]) // Specify a document ID (or let Firestore generate one)
				.set({
					data: JSON.stringify(data), // Assuming currentInProgress is an object you want to store
					timestamp: new Date().toLocaleString(), // Optional: add a timestamp
				});
		}
		else {
			console.warn(data.error);
			const todayDate = new Date().toLocaleString().replaceAll('/', '-').replace(' ', '').split(','); // Get the current date
			firestore()
				.collection(`Errors/checklist/${response.checklist}/QueElse/${todayDate[0]}`)
				.doc(todayDate[1]) // Specify a document ID (or let Firestore generate one)
				.set({
					data: JSON.stringify(data), // Assuming currentInProgress is an object you want to store
					timestamp: new Date().toLocaleString(), // Optional: add a timestamp
				});
		}
	} catch (error) {
		//segmentClient.track('Responses Added Failed', error);
		console.warn(error);
		yield put(sendResponseFail(error));
		const todayDate = new Date().toLocaleString().replaceAll('/', '-').replace(' ', '').split(','); // Get the current date
		firestore()
			.collection(`Errors/checklist/${response.checklist}/QueCatch/${todayDate[0]}`)  // Collection path
			.doc(todayDate[1])  // Document for today's date (e.g., 2024-09-26)
			.set({
				error: JSON.stringify(error),  // Assuming 'error' is an object you want to store
				timestamp: new Date().toLocaleString(),  // Optional: add a timestamp
			})
	}
}


function dataURItoBlob(dataURI) {
	// convert base64/URLEncoded data component to raw binary data held in a string
	let byteString;
	if (dataURI.split(',')[0].indexOf('base64') >= 0) { byteString = atob(dataURI.split(',')[1]); } else { byteString = unescape(dataURI.split(',')[1]); }

	// separate out the mime component
	const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	// write the bytes of the string to a typed array
	const ia = new Uint8Array(byteString.length);
	for (let i = 0; i < byteString.length; i += 1) {
		ia[i] = byteString.charCodeAt(i);
	}

	return new Blob([ia], { type: mimeString });
}


function* responseHandler({ response }) {
	try {
		console.log(response, "responseHandler");

		yield put(sendInQue(response));
	} catch (error) {
		firestore()
			.collection(`Errors/checklist/${response.checklist}/responseHandler/${todayDate[0]}`)  // Collection path
			.doc(todayDate[1])  // Document for today's date (e.g., 2024-09-26)
			.set({
				options: options,
				error: JSON.stringify(error),  // Assuming 'error' is an object you want to store
				timestamp: new Date().toLocaleString(),  // Optional: add a timestamp
			})
	}
}


function* responseQueHandler({ response }) {
	try {
		const keys = Object.keys(response);
		const pictures = [];

		console.log(response, "response333");
		// Collect all pictures from the response
		keys.forEach((key) => {
			const isPic = key.includes('pic');
			if (isPic && response[key]) {
				const name = `${API() !== "https://biz.safebuildingsapp.ca" ? 'dev-' : ''}patrol-data/ch_${response.checklist}_${response[key.replace('pic', 'date')]}.jpeg`;
				if (response[key]?.uri) {
					pictures.push({ pic: response[key], name: name, key: key });
				}
				else {
					console.log(response[key], "response[key]");

				}

			}
		});

		// Check if we have found any pics in our response
		if (pictures.length > 0) {
			// Prepare an object without the pics in it for the fallback scenario
			console.log(pictures, "pics");
			const responseWithoutPics = { ...response };
			pictures.forEach(({ key, name }) => {
				if (response.hasOwnProperty(key)) {
					responseWithoutPics[key] = name;
				}
			});

			console.log(responseWithoutPics, "responseWithoutPics");
			response = responseWithoutPics;

			let hasError = false;

			// Split pics into batches of 20

			//segmentClient.track('Final checklist JSON', response);
			if (!hasError) {
				yield call(sendQueResponse, response);
			} else {
			}

			yield put(sendPicturesInQue(pictures));
		} else {
			//segmentClient.track('Final checklist JSON(No Images)', response);
			// In case of no pics in the response
			yield call(sendQueResponse, response);
		}
	} catch (error) {
		console.log(error, "error");

		//segmentClient.track('sendResponseFail', error);
		yield put(sendResponseFail(error));

		const todayDate = new Date().toLocaleString().replaceAll('/', '-').replace(' ', '').split(','); // Get the current date
		firestore()
			.collection(`Errors/checklist/${response.checklist}/catch/${todayDate[0]}`)  // Collection path
			.doc(todayDate[1])  // Document for today's date (e.g., 2024-09-26)
			.set({
				error: JSON.stringify(error),  // Assuming 'error' is an object you want to store
				timestamp: new Date().toLocaleString(),  // Optional: add a timestamp
			})
	}
}


function* responsePictureHandler({ picture }) {
	try {
		console.log(picture, "picture433");

		const pics = picture;

		// Check if we have found any pics in our response
		if (pics.length > 0) {
			// Function to handle the form data creation and sending request

			let uploadedFiles = [];
			for (const { name, pic } of pics) {
				console.log(pic?.uri, 'pic?.uri');
				const fileExists = pic?.uri;
				console.log(fileExists, 'fileExists');

				if (pic?.uri && fileExists) {
					const fileType = pic.uri.split(';')[0].split('/')[1];
					const file = dataURItoBlob(pic.uri);
					const uriParts = pic.uri.split('.');
					const fileName = name;
					const mimeType = `image/jpeg`;

					try {
						const s3Result = yield call(uploadToS3, pic.uri, fileName, mimeType);
						console.log('S3 Upload Success:', s3Result);
						uploadedFiles.push(s3Result?.Key);
					} catch (err) {
						console.warn('Upload failed for', fileName, err);
					}
				}
				else if (!fileExists) {
					const todayDate = new Date().toLocaleString().replaceAll('/', '-').replace(' ', '').split(','); // Get the current date

					// uploadedFiles.push(name); 
					firestore()
						.collection(`Errors/checklist/Picture/NoFileExists/${todayDate[0]}`)  // Collection path
						.doc(todayDate[1])  // Document for today's date (e.g., 2024-09-26)
						.set({
							fileName: name,  // Assuming 'error' is an object you want to store
							timestamp: new Date().toLocaleString(),  // Optional: add a timestamp
						})
				}
			}

			if (uploadedFiles.length === 0) {
				console.warn('No files uploaded');
				return null;
			}
			else {
				yield put(sendQuePictureSuccess(uploadedFiles));
			}

			console.log(uploadedFiles, "uploadedFiles");



		}
	} catch (error) {
		console.log(error, "error");

		//segmentClient.track('sendResponseFail', error);
		yield put(sendResponseFail(error));

		const todayDate = new Date().toLocaleString().replaceAll('/', '-').replace(' ', '').split(','); // Get the current date
		firestore()
			.collection(`Errors/checklist/Picture/catch/${todayDate[0]}`)  // Collection path
			.doc(todayDate[1])  // Document for today's date (e.g., 2024-09-26)
			.set({
				error: JSON.stringify(error),  // Assuming 'error' is an object you want to store
				timestamp: new Date().toLocaleString(),  // Optional: add a timestamp
			})
	}
}



// Checklist related
function* retreiveNFCSelectTitle(checklists) {
	const ids = [];
	checklists.forEach((checklist) => {
		const { questions } = JSON.parse(checklist.field8);
		questions.forEach(({ NFCValidation, NFCTag }) => {
			if (NFCValidation && NFCTag) {
				if (String(NFCTag).length > 0) {
					String(NFCTag).split(',').forEach((tag) => {
						ids.push(tag);
					});
				}
			}
		});
	});

	if (ids.length > 0) {
		const url = `${API()}/action/fetchGenData`;
		const options = {
			url,
			method: 'GET',
			params: {
				ajax: true,
				ids: ids.join(','),
				field1: 'nfc',
			},
		};
		try {
			const { data } = yield call(request, options);
			const newChecklists = [];
			checklists.forEach((checklist) => {
				const { questions } = JSON.parse(checklist.field8);
				const newQuestions = [];
				questions.forEach((question) => {
					let tags = String(question.NFCTag);
					if (question.NFCValidation && tags && tags.length) {
						const NFCTitle = [];
						const NFCData = [];
						tags.split(',').forEach((tag) => {
							NFCTitle.push(data.find((el) => String(el.id) === tag)?.field2 ?? '');
							NFCData.push(data.find((el) => String(el.id) === tag)?.field3 ?? '');
						});
						newQuestions.push({ ...question, NFCTitle, NFCData });
					} else {
						newQuestions.push(question);
					}
				});
				const newChecklist = {
					...checklist,
					field8: JSON.stringify({ questions: newQuestions }),
				};
				newChecklists.push(newChecklist);
			});
			if (data !== 'error') {
				yield put(checklistLoadedSuccess(newChecklists));
			} else {
				console.warn(data);
				yield put(checklistLoadedFail(data));
			}
		} catch (err) {
			console.warn(err);
			yield put(checklistLoadedFail(err));
		}
	} else {
		yield put(checklistLoadedSuccess(checklists));
	}
}

function* loadChecklist({ id, ids }) {
	const url = `${API()}/action/fetchGenData`;
	const options = {
		url,
		method: 'POST',
		params: {
			ajax: true,
			field1: 'checklist',
			ids: id ? id.toString() : ids,
		},
	};

	try {
		const { data } = yield call(request, options);
		if (typeof data === 'object') {
			// yield put(checklistLoadedSuccess(data));
			yield call(retreiveNFCSelectTitle, data);
			// yield call(loadResponses, data[0].id);
			const user = yield call(login.getUser);
			yield put(loadNotifications(user));
		} else {
			yield put(checklistLoadedFail(data));
		}
	} catch (err) {
		console.warn(err);
		yield put(checklistLoadedFail(err));
	}
}

function* loadResponsesByIds({ ids }) {
	const url = `${API()}/action/fetchGenData`;
	const options = {
		url,
		method: 'POST',
		params: {
			ajax: true,
			field1: 'response',
			ids,
		},
	};
	try {
		const { data } = yield call(request, options);
		if (data !== 'error') {
			yield put(loadResponsesSuccess(data));
			// load the checklists that come with
			let checklistIds = [];
			data.forEach((response) => {
				checklistIds.push(response.field2);
			});
			checklistIds = _.uniq(checklistIds);
			yield fork(loadChecklist, { id: null, ids: checklistIds });
		} else {
			console.warn(data);
			yield put(loadResponsesFail(data));
		}
	} catch (err) {
		console.warn(err);
		yield put(loadResponsesFail(err));
	}
}

export default function* ChecklistsProviderSaga() {
	yield takeLatest(LOAD_CHECKLIST, loadChecklist);
	yield takeLatest(LOAD_CHECKLIST_RESPONSES, loadResponses);
	yield takeLatest(SEND_RESPONSE, responseHandler);
	yield takeLatest(LOAD_RESPONSES_BY_IDS, loadResponsesByIds);
	yield takeLatest(SEND_PICTURE_RESPONSE, responsePictureHandler);
	yield takeLatest(SEND_QUE_RESPONSE, responseQueHandler);
}
